import { ListaAgrupamentosDeStatusContrato, ListaAgrupamentosDeStatusPagamento, ListaAgrupamentosDeStatusPedido, StatusAnaliseCadastral } from './constants'

export const ProcessosDeVenda = {
  statusPedido: 'Processo da venda',
  statusPagamento: 'Processo de pagamento',
  statusCredito: 'Processo de análise de crédito',
  statusContrato: 'Processo do contrato'
}

export const OpcoesProcessoVenda = [
  { name: ListaAgrupamentosDeStatusPedido.Bloqueado, value: ListaAgrupamentosDeStatusPedido.Bloqueado },
  { name: ListaAgrupamentosDeStatusPedido.Rascunho, value: ListaAgrupamentosDeStatusPedido.Rascunho },
  { name: ListaAgrupamentosDeStatusPedido.AguardandoEnvio, value: ListaAgrupamentosDeStatusPedido.AguardandoEnvio },
  { name: ListaAgrupamentosDeStatusPedido.Pagamento, value: ListaAgrupamentosDeStatusPedido.Pagamento },
  { name: ListaAgrupamentosDeStatusPedido.Finalizado, value: ListaAgrupamentosDeStatusPedido.Finalizado },
  { name: ListaAgrupamentosDeStatusPedido.Falha, value: ListaAgrupamentosDeStatusPedido.Falha }
]

export const OpcoesProcessoAnaliseCredito = [
  { name: StatusAnaliseCadastral.Pendente, value: StatusAnaliseCadastral.Pendente },
  { name: StatusAnaliseCadastral.EmAnalise, value: StatusAnaliseCadastral.EmAnalise },
  { name: StatusAnaliseCadastral.Aprovado, value: StatusAnaliseCadastral.Aprovado },
  { name: StatusAnaliseCadastral.Reprovado, value: StatusAnaliseCadastral.Reprovado },
  { name: StatusAnaliseCadastral.PendenciaCadastral, value: StatusAnaliseCadastral.PendenciaCadastral }
]

export const OpcoesProcessoPagamento = [
  { name: ListaAgrupamentosDeStatusPagamento.Falha, value: ListaAgrupamentosDeStatusPagamento.Falha },
  { name: ListaAgrupamentosDeStatusPagamento.EmEspera, value: ListaAgrupamentosDeStatusPagamento.EmEspera },
  { name: ListaAgrupamentosDeStatusPagamento.Pendente, value: ListaAgrupamentosDeStatusPagamento.Pendente },
  { name: ListaAgrupamentosDeStatusPagamento.Realizado, value: ListaAgrupamentosDeStatusPagamento.Realizado }
]

export const OpcoesProcessoContrato = [
  { name: ListaAgrupamentosDeStatusContrato.EmEspera, value: ListaAgrupamentosDeStatusContrato.EmEspera },
  { name: ListaAgrupamentosDeStatusContrato.Pendente, value: ListaAgrupamentosDeStatusContrato.Pendente },
  { name: ListaAgrupamentosDeStatusContrato.Assinado, value: ListaAgrupamentosDeStatusContrato.Assinado },
  { name: ListaAgrupamentosDeStatusContrato.Negado, value: ListaAgrupamentosDeStatusContrato.Negado },
  { name: ListaAgrupamentosDeStatusContrato.Falha, value: ListaAgrupamentosDeStatusContrato.Falha }
]
